<template>
  <v-main>
    <Card style="margin-bottom: 24px" title="Вход в кабинет партнёра">
      <v-form v-on:submit.prevent>
        <v-text-field
          v-show="!emailLogin"
          label="Номер телефона"
          placeholder=" "
          :error="errdesc.length > 0"
          :error-messages="errdesc"
          outlined
          autofocus
          required
          style="text-align: center"
          v-mask="'+7(9##) ###-##-##'"
          v-model="phone"
          name="phone"
          type="text"
          @input="clearErrdesc"
        ></v-text-field>

        <v-text-field
          v-show="emailLogin"
          label="E-mail"
          placeholder=" "
          :error="errdesc.length > 0"
          :error-messages="errdesc"
          outlined
          autofocus
          required
          style="text-align: center"
          v-model="email"
          name="email"
          type="text"
          @input="clearErrdesc"
        ></v-text-field>

        <v-text-field
          hide-details
          label="Пароль"
          placeholder=" "
          required
          outlined
          v-model="pass"
          prepend-inner-icon="mdi-lock-outline"
          :type="show ? 'text' : 'password'"
          @keyup.enter="send"
        >
          <template v-slot:append>
            <v-icon @click="show = !show" tabindex="-1" v-if="show">mdi-eye</v-icon>
            <v-icon @click="show = !show" tabindex="-1" v-else>mdi-eye-off</v-icon>
          </template>
        </v-text-field>
      </v-form>
      <v-checkbox color="#88BD1F" v-model="emailLogin" tabindex="-1">
        <template v-slot:label>
          <div class="text-link">Вход по E-mail</div>
        </template>
      </v-checkbox>
      <v-btn :disabled="!valid" x-large block color="primary" @click="send">Продолжить</v-btn>
    </Card>
    <div class="font--action-small font--color_light text-center mb-6">
      <router-link class="text-link text-decoration-none" to="/account/recovery">Я Забыл пароль</router-link>
    </div>
    <div class="font--action-small font--color_light text-center">
      <span class="mr-1">Впервые здесь?</span>
      <router-link class="text-link text-decoration-none" to="/account/register">зарегистрироваться</router-link>
    </div>
  </v-main>
</template>

<script>
import punycode from "punycode";
import { mask } from "vue-the-mask";
import Card from "@/components/login/Card";
import { mapGetters, mapMutations, mapActions } from "vuex";
import { patternEmailWithCyrillic } from "@/utils/helpers";

export default {
  directives: { mask },
  data() {
    return {
      emailLogin: false,
      show: false,
      email: null,
    };
  },
  components: {
    Card,
  },
  computed: {
    ...mapGetters("common", ["errdesc"]),
    ...mapGetters({
      statePhone: "login/phone",
      statePass: "login/pass",
      phoneNumber: "login/phoneNumber",
    }),

    isPhone() {
      return this.phoneNumber.length === 11;
    },

    isEmail() {
      return patternEmailWithCyrillic.test(this.email);
    },

    isPass() {
      return !!this.pass && this.pass.length > 0;
    },

    isLogin() {
      return this.emailLogin ? this.isEmail : this.isPhone;
    },

    valid() {
      return this.isPass && this.isLogin;
    },

    phone: {
      get() {
        return this.statePhone;
      },
      set(value) {
        this.setPhone(value);
      },
    },

    pass: {
      get() {
        return this.statePass;
      },
      set(value) {
        this.setPass(value);
      },
    },
  },
  methods: {
    ...mapActions("common", ["clearErrdesc"]),
    ...mapActions("login", ["login"]),
    ...mapMutations("login", ["setPhone", "setPass"]),

    send() {
      const data = { pass: this.pass };
      if (this.email || this.phoneNumber) {
        if (this.emailLogin) {
          data.login = punycode.toASCII(this.email);
        } else {
          data.phone = this.phoneNumber;
        }
        this.login(data);
      }
    },
  },
  destroyed() {
    this.clearErrdesc();
    this.setPass("");
  },
};
</script>
